import { AiOutlineClose, AiOutlineArrowLeft } from "react-icons/ai";
import { useState, useEffect } from "react";
import swal from "sweetalert";

import { serialize, original } from "../../functions/helper";
import API from "../../api/baseUrl";
import config from "../../config.json";
import loader from "../../assets/loader.svg";
import { paymentService } from "../../api/payment";
import { useHistory, useLocation } from "react-router-dom";

export default function Modal({ showModal, closeModal, data }) {
  const Login_User_Token = localStorage.getItem("user_login_token");
  const Login_User_cp = localStorage.getItem("user_login_cp");
  const history = useHistory();
  const { state } = useLocation();

  const [loading, setLoading] = useState(true);
  const [loadTimeData, setLoadTimeData] = useState(true);
  const [timeData, setTimeData] = useState([]);
  const [visits, setVisits] = useState([]);
  const [sdate, setSdate] = useState("");
  // const [desc, setDesc] = useState("");

  useEffect(() => {
    if (showModal) handleSearchVisit();
  }, [showModal]);

  window.addEventListener("click", (e) => {
    if (
      !e.target.closest(".modal__box") &&
      !e.target.closest(".table-report tr td") &&
      !e.target.closest(".fast-visit-page__form_btn") &&
      !e.target.closest(".button") &&
      !e.target.closest(".user-visit__head_back-btn") &&
      !e.target.closest(".swal-overlay")
    ) {
      closeModal();
    }
  });

  // console.log(showModal);

  const handleSearchVisit = async (e) => {
    try {
      setVisits([]);
      setLoading(true);

      const resVisit = await API.post(
        serialize({
          id: 1712,
          sp_param: `'${Login_User_Token}','${Login_User_cp}','0','0','0','0','0','${data.fday}','${data.tday}','${data.cs.value}','${data.cp_expert.value}','${data.c_week.value}'`,
          Login_User_Token,
          Login_User_cp,
        })
      );

      let resVisitParse = original(resVisit.data, false);

      setVisits(resVisitParse);
      setLoading(false);
      // setValuesVisit({
      //   fday: data.fday,
      //   tday: data.tday,
      //   c_week: data.c_week,
      //   cs: data.cs,
      //   cp_expert: data.cp_expert,
      // });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchTimes = async (newState) => {
    try {
      setLoadTimeData(true);

      const resVisit = await API.post(
        serialize({
          id: 1713,
          sp_param: `'${Login_User_Token}','${Login_User_cp}','0','0','0','0','0','${data.fday}','${data.tday}','${data.cs.value}','${data.cp_expert.value}','${newState}','${data.c_week.value}'`,
          Login_User_Token,
          Login_User_cp,
        })
      );

      let resTimetParse = original(resVisit.data, false);

      console.log(resTimetParse);

      setTimeData(resTimetParse);
      setLoadTimeData(false);
      // setValuesVisit({
      //   fday: data.fday,
      //   tday: data.tday,
      //   c_week: data.c_week,
      //   cs: data.cs,
      //   cp_expert: data.cp_expert,
      // });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddVisit = async (e) => {
    e.preventDefault();
    try {
      if (!sdate) {
        swal("لطفا نوبت مورد نطر را انتخاب کنید");
        return;
      }

      const res = await API.post(
        serialize({
          id: 1586,
          sp_param: `'${data.fday}','${data.tday}','${data.c_week.value}','${data.cs.value}','${data.cp_expert.value}','${sdate}','${data.desc}','${Login_User_cp}'`,
          Login_User_Token,
          Login_User_cp,
        })
      );
      let resParse = original(res.data, false);

      if (resParse[0].s_result > "0") {
        handleSearchVisit();
        swal("", `وقت با موفقیت ثبت شد`, "success");
      } else {
        swal("", `${resParse[0].s_message}`, "warning");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetVisitId = async (item) => {
    try {
      const res = await API.post(
        serialize({
          id: 1714,
          sp_param: `'${Login_User_Token}','${Login_User_cp}','0','101','0','0','0','${item.id_timeing}','${data.fday}','${data.tday}','0','${data.cs.value}','${data.cp_expert.value}','${sdate}','${data.desc}','0'`,
          Login_User_Token,
          Login_User_cp,
        })
      );
      let resParse = original(res.data, false);
      console.log(resParse);
      if (resParse[0].s_result > "0") {
        // const dataConfig = {
        // 	fday: data.fday,
        // 	tday: data.tday,
        // 	cs: data.cs.value,
        // 	cp_expert: data.cp_expert.value,
        // 	sdate: item.sdate,
        // };
        // // localStorage.setItem("fastVisitData", JSON.stringify(dataConfig));
        if (config.enable_payment_visit)
          paymentService(data.initialCode, data.phoneNumber, item.cost, data.desc, 0, 0, 111, 1);
        else {
          swal("", `${resParse[0]?.s_message.split("\r").map((item) => (item ? item + "\n" : ""))}`, "success", {
            button: "تایید",
          }).then((value) => {});
          history.push({
            pathname: "/visit/info",
            state,
          });
        }
      } else {
        swal("", `${resParse[0].s_message}`, "warning");
      }
      console.log(resParse);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickSdate = (item) => {
    setSdate(item.sdate);
    handleSearchTimes(item.sdate);
  };

  const handleClickTime = (item) => {
    handleSetVisitId(item);
  };

  return (
    <div className={`modal fast-visit-modal ${showModal ? "modal__show" : ""}`}>
      <div className="modal__box">
        <div className="modal__head">
          <h3 className="modal__head_title">رزرو نوبت</h3>
          <button className="modal__head_close" onClick={closeModal}>
            <AiOutlineClose />
          </button>
        </div>

        <div className="modal__body">
          {/* <form> */}
          <div className="user-visit__lists_items">
            {!loading ? (
              !sdate ? (
                visits.length && visits[0].sdate ? (
                  visits.map((item, index) => (
                    <div className="user-visit__lists_item" key={index}>
                      <div className="user-visit__lists_info">
                        <span className="user-visit__lists_item__num">{item.S_NUM}</span>
                        <span className="user-visit__lists_item__date">{item.sdate}</span>
                        {item.cost ? (
                          <span className="user-visit__lists_item__cost">
                            {Number(item.cost).toLocaleString()} ریال
                          </span>
                        ) : (
                          <></>
                        )}
                      </div>
                      <button
                        className="button"
                        type="button"
                        onClick={() => handleClickSdate(item)}
                        style={{ minWidth: 100 }}
                      >
                        انتخاب تاریخ
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="mini-loading">
                    <p>متاسفانه نوبتی با درخواست شما پیدا نشد !!!</p>
                  </div>
                )
              ) : !loadTimeData ? (
                <>
                  <div className="user-visit__head">
                    <button className="user-visit__head_back-btn" onClick={() => setSdate("")}>
                      <AiOutlineArrowLeft />
                    </button>
                  </div>
                  {timeData.length ? (
                    timeData.map((item, index) => (
                      <div className="user-visit__lists_item" key={index}>
                        <div className="user-visit__lists_info">
                          <span className="user-visit__lists_item__date">{item.stime + " - " + item.etime}</span>
                          {item.cost ? (
                            <span className="user-visit__lists_item__cost">
                              {Number(item.cost).toLocaleString()} ریال
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        <button
                          className="button"
                          type="button"
                          onClick={() => handleClickTime(item)}
                          style={{ minWidth: 100 }}
                        >
                          ثبت نوبت
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="mini-loading">
                      <p>متاسفانه زمان با درخواست شما پیدا نشد !!!</p>
                    </div>
                  )}
                </>
              ) : (
                <div className="mini-loading">
                  <img src={loader} />
                </div>
              )
            ) : (
              <div className="mini-loading">
                <img src={loader} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
